import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withLang } from "./withLang";

export const clubPageApi = createApi({
  reducerPath: "clubPageApi",
  baseQuery: withLang(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_API_BASE_URL}/apiv2/clubpage/`,
    }),
  ),
  endpoints: (builder) => ({
    getClubPageInfo: builder.mutation({
      query: (body) => ({
        url: `get`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const { useGetClubPageInfoMutation } = clubPageApi;
